import { ErrorHandler } from '@angular/core'

export abstract class SelectiveExceptionHandler implements ErrorHandler {

  public abstract handleError(exception: any, stackTrace?: any, reason?: string)

  public handledErrors(): Array<{new (): Error}> {
    return [Error]
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/helpers/exception-handlers/selective-exception-handler.ts